export const config = {
  // API_URL: "http://localhost:4011/api/v1",
  API_URL:
    process.env.NODE_ENV === "production"
      ? "https://order-api.lunet.se/api/v1"
      : "http://localhost:4011/api/v1",
};
